export const checkboxStyle = {
	wrapper: {
		position: 'relative',
	},

	label: {
		height: '20px',
	},

	error: {
		'&.MuiFormHelperText-root.Mui-error': {
			bottom: '4px',
		},
	},
};
